import { cmsApiConfig } from '../../cmsConfig';
import { BisnodeCompany } from '../../types/Bisnode/BisnodeCompany';
import { BisnodePerson } from '../../types/Bisnode/BisnodePerson';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BisnodeWorksite } from '../../types/Bisnode/BisnodeWorksite';

export const bisnodeApi = createApi({
  reducerPath: 'bisnodeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${cmsApiConfig.url}/bisnode`,
    headers: {
      'Content-Type': 'application/json',
      credentials: 'include',
      'x-csrf': '1',
    },
  }),

  tagTypes: ['BisnodePerson'],
  endpoints: (builder) => ({
    getPerson: builder.mutation<
      BisnodePerson,
      { socialSecurityNumber: string }
    >({
      query: (body) => ({
        method: 'POST',
        url: `/person`,
        body,
      }),
      transformErrorResponse: (response) => {
        const data = response.data as { message?: string };
        return {
          status: response.status,
          message: data?.message || 'Unknown error',
        };
      },
    }),
    getWorksites: builder.query<BisnodeWorksite[], string>({
      query: (orgNumber) => `/worksites?orgNumber=${orgNumber}`,
    }),
    getCompanies: builder.query<BisnodeCompany[], string>({
      query: (searchInput) => `/companies?searchInput=${searchInput}`,
    }),
    getCompanyById: builder.query<BisnodeCompany, string>({
      query: (id) => `/companies/${id}`,
    }),
  }),
});

export const {
  useGetPersonMutation,
  useGetWorksitesQuery,
  useLazyGetCompaniesQuery,
  useLazyGetCompanyByIdQuery,
} = bisnodeApi;
